var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVariant6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    fillOpacity: 0.12,
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M15.504 13.002h-.5v10.637h1v-9.637h10.05v5.414a.5.5 0 0 0 .5.5h5.45v3.86h1v-4.334a.583.583 0 0 0 0-.053v-.182l-.138-.137a.538.538 0 0 0-.018-.018l-5.926-5.889a.476.476 0 0 0-.03-.03l-.132-.131H15.504Zm11.55 1.702v4.212h4.238l-4.237-4.212Zm2.016 11.568h4.43v1h-3.43v2.273h2.572v1H30.07V33h-1v-6.728Zm-14.57 0h2.214c.694 0 1.364.263 1.86.738a2.5 2.5 0 0 1 .783 1.808 2.5 2.5 0 0 1-.782 1.808 2.696 2.696 0 0 1-1.86.738H15.5V33h-1v-6.728Zm1 4.092h1.214c.443 0 .864-.169 1.17-.461a1.5 1.5 0 0 0 .473-1.085 1.5 1.5 0 0 0-.473-1.085 1.695 1.695 0 0 0-1.17-.46H15.5v3.09Zm6.357-4.092h-.5V33h2.215c.92 0 1.808-.349 2.466-.977a3.3 3.3 0 0 0 1.034-2.387 3.3 3.3 0 0 0-1.034-2.387 3.574 3.574 0 0 0-2.466-.977h-1.715Zm.5 5.728v-4.728h1.215c.67 0 1.309.255 1.776.7a2.3 2.3 0 0 1 .724 1.664 2.3 2.3 0 0 1-.724 1.664c-.467.446-1.106.7-1.776.7h-1.215Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 14.5,
    x2: 33.5,
    y1: 23.001,
    y2: 23.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariant6);
export default __webpack_public_path__ + "static/media/variant6.5023db131f46ab9963fed588dea09c3b.svg";
export { ForwardRef as ReactComponent };